
export const AppRoutes = {
  Keys: 'keys',
}
